const errorMessages: Record<string, string> = {
  // 400
  ADMIN_ALREADY_EXIST: "Admin sudah ada",

  // Attendance
  ALREADY_CHECKED_IN: "Sudah melakukan check-in",
  NOT_YET_CHECKED_IN: "Belum melakukan check-in",
  NOT_YET_CHECKED_OUT: "Belum melakukan check-out",
  SHIFT_EXPIRED: "Shift sudah berakhir",
  CURRENT_TIME_IS_NOT_BETWEEN_SHIFT_CHECK_IN_TIME_AND_CHECK_OUT_TIME:
    "Waktu saat ini tidak berada di antara jam check-in dan check-out shift",

  // Shift
  CHECK_IN_TIME_MUST_BE_LESS_THAN_CHECK_OUT_TIME:
    "Jam check-in harus lebih kecil dari jam check-out",
  TOLERANCE_MUST_BE_BIGGER_OR_EQUAL_TO_ZERO:
    "Toleransi harus lebih besar atau sama dengan nol",
  SHIFT_EXPIRED_DATE_MUST_BE_LATER_THAN_TODAY:
    "Tanggal berakhir shift harus lebih besar dari hari ini",

  // Overtime
  MEMBER_CANNOT_BACK_UP_SELF: "Member tidak bisa menggantikan dirinya sendiri",
  OVERTIME_ALREADY_ADDED: "Lembur sudah ditambahkan",

  // Password Management
  WRONG_PASSWORD: "Password salah",
  IS_FIRST_LOGIN_MUST_BE_TRUE: "Login pertama harus bernilai benar",

  // Image
  FILE_MUST_BE_AN_IMAGE: "File harus berupa gambar",

  // Excel
  COLUMN_NOT_EXIST: "Kolom tidak ditemukan",

  // Event Attendance
  ALREADY_ATTEND_EVENT: "Sudah menghadiri event",
  EVENT_MUST_BE_TODAY: "Event hanya bisa dihadiri hari ini",

  // 401
  WRONG_USERNAME_OR_PASSWORD: "Username atau password salah",
  INVALID_TOKEN: "Token tidak valid",

  // 403
  WRONG_INIT_KEY: "Init key salah",
  USER_TYPE_NOT_ALLOWED: "Tipe user tidak diizinkan",

  // 404
  ADMIN_NOT_FOUND: "Admin tidak ditemukan",
  MEMBER_NOT_FOUND: "Member tidak ditemukan",
  LOCATION_NOT_FOUND: "Lokasi tidak ditemukan",
  OVERTIME_NOT_FOUND: "Data lembur tidak ditemukan",
  PATROL_NOT_FOUND: "Patroli tidak ditemukan",
  SHIFT_NOT_FOUND: "Shift tidak ditemukan",
  ATTENDANCE_NOT_FOUND: "Absensi tidak ditemukan",
  NOTIFICATION_NOT_FOUND: "Notifikasi tidak ditemukan",
  EVENT_NOT_FOUND: "Event tidak ditemukan",
};

export default errorMessages;
